import { vsingleton } from '@niknevis/vue-modules'
import { Ziggy } from '@/modules/shared/helpers/facades/ziggy'

@vsingleton()
export class PanelCampaignRoute {

  allCampaigns() {
    return Ziggy
      .route('panel.api.all_campaigns')
      .toString()
  }

}